import React, { useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles, styled } from '@material-ui/core/styles';

import i18next from 'i18next';
import { Done } from '@material-ui/icons';
import { Chip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const languageOptions = [{
  key:1, labelKey: 'language-ar', lang: 'ar',
},
{
  key: 2 , labelKey: 'language-en', lang: 'en',
}]

const getCurrentLanguage = () => {
  const language = i18next.resolvedLanguage || i18next.language || languageOptions[0].lang;
  const normalizedLanguage = language.split("-")[0];
  return languageOptions.some((option) => option.lang === normalizedLanguage)
    ? normalizedLanguage
    : languageOptions[0].lang;
};

const useStyles = makeStyles((theme) => ({
    chip:{
    paddingLeft:'10px',
    paddingRight: '10px',
    marginLeft: '10px'
  },
}));

const ListItem = styled('li')(({theme}) =>({
  margin: theme.spacing(0.5),
}));

const SelectLanguage = (props)=>{
  const { t } = useTranslation(["forms"]);
  const classes = useStyles();
  const [lang, setLang]=useState(getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChanged = () => setLang(getCurrentLanguage());
    i18next.on("languageChanged", handleLanguageChanged);
    return () => i18next.off("languageChanged", handleLanguageChanged);
  }, []);
    return (
            <Container
                style={{
                  display:'flex',
                  justifyContent:'center',
                  flexWrap:'wrap',
                  listStyle:'none',
                  padding:'5px',
                  margin:'0px',
                  direction: 'rtl',
                }}
                component="ul" >
              {
                
                languageOptions.map(lg=>{
                  // return <></>
                  return <ListItem key={lg.key}>
                    {
                      lg.lang ===lang ?
                      <Chip 
                        className={classes.chip} 
                        label={t(`forms:${lg.labelKey}`)} 
                        icon={<Done style={{color:'#fff'}}/>}
                        style={{backgroundColor: '#ff0000',
                        color:'#ffffff'}}
                        clickable
                      />:
                      <Chip 
                        className={classes.chip} 
                        label={t(`forms:${lg.labelKey}`)} 
                        variant='outlined'
                        color={'default'}
                        onClick={()=>{window.localStorage.setItem('oraxUserLanguageSelected', 'true'); setLang(lg.lang); i18next.changeLanguage(lg.lang)}}
                      />
                    }
                  </ListItem>
                })}
            </Container>
           
    )
}

export default SelectLanguage;